import { IDs } from '../../helpers/IDs';
import { isValid } from '../../main/functions/validData';
import { lazyInject } from '../../services/inversify';
import { onFormChangeUniversal } from './functions/onFormChange';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldUniversal } from './functions/validateField';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface DateneingabeFahrzeugProps {
    data: any;
    fahrzeugSelected: any;
}

export interface DateneingabeFahrzeugState {
    hiddenFormFields: Array<any>;
    validRestriction: string;
}

export class DateneingabeFahrzeug extends React.Component<DateneingabeFahrzeugProps, DateneingabeFahrzeugState> {

    constructor(props: any) {
        super(props);
        this.state = {
            hiddenFormFields: [],
            validRestriction: null
        };
        this.onFormChange = this.onFormChange.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        const status: number = (this.props.fahrzeugSelected || {}).status || null;
        this.setState({ hiddenFormFields: +status !== 2 ? ['jahr_status'] : [] });
    }

    onFormChange(WFormData: any): void {
        const status: number = +WFormData.getValue('status') || null;
        onFormChangeUniversal(IDs.ENT_FAHRZEUGE, WFormData, this);
        this.setState({ hiddenFormFields: +status !== 2 ? ['jahr_status'] : [] });
    }

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_FAHRZEUGE}
                module={IDs.MOD_ETOOL}
                directEditFormularOf={{ tid: (this.props.fahrzeugSelected || {}).tid || null }}
                customClass='Custom-ETA'
                formLayout='flowV2'
                customCssStyle={{
                    formcontainer: { marginTop: 'unset', padding: 'unset' }
                }}
                inlineFormular
                skipCloseAction
                // formAutoSave
                hiddenFormFields={this.state.hiddenFormFields}
                customFormConfig={{ standort_tid: { readonly: true } }}
                onFormChange={this.onFormChange}
                hideTitel
                validateField={this.validateField}
                validRestriction={this.state.validRestriction}
                callBeforeOnFormSave={(data: any, callback: () => void) =>
                    this.setState(
                        { validRestriction: !isValid(data || {}, IDs.ENT_FAHRZEUGE) ? 'stop' : null },
                        () => callback()
                    )
                }
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_FAHRZEUGE)}
                globalData={this.props.data}
            />
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_FAHRZEUGE, key, value, data, onValueChange);
    }
}
